var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('app-header',{attrs:{"title":_vm.headerTitle,"theme":_vm.theme}},[_c('template',{slot:"right"},[_vm._t("header-right")],2)],2),_c('v-main',[_vm._t("map"),_vm._t("default"),_c('app-sidebar')],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }